import createModelInstance from 'utils/createModelInstance';
import validateForm from 'utils/validateForm';
import Address from 'models/Address';
import RETURN_TO_OPTIONS from 'constants/returnToOptions';
import isEmpty from 'lodash/isEmpty';

const PHONE_TYPES = Object.freeze({ mobile: 'phone_mobile', home: 'phone_home', work: 'phone_work'});
const Owner = (ownerObj = {}) => {
    let newOwnerObj = {
        id: '',
        firstName: '',
        lastName: '',
        phoneNumber: 
        Object.hasOwnProperty.call(ownerObj, 'phone_mobile') && ownerObj.phone_mobile
            ? ownerObj.phone_mobile : Object.hasOwnProperty.call(ownerObj, 'phone_home') && ownerObj.phone_home
            ? ownerObj.phone_home : Object.hasOwnProperty.call(ownerObj, 'phone_work') && ownerObj.phone_work
            ? ownerObj.phone_work : '',
        email: Object.hasOwnProperty.call(ownerObj, 'email_address') && ownerObj.email_address
            ? ownerObj.email_address : '',
        address: '',
        returnTo: ''
    };

    newOwnerObj = createModelInstance(newOwnerObj, ownerObj);
    let addressObj = {};
    // The format from the booking owner form
    if (Object.hasOwnProperty.call(ownerObj, 'address')) {
        addressObj = ownerObj.address;
    } else {
        // Format from sugarAPI
        for (const key in ownerObj) {
            if (key.includes('primary_address_')) {
                const newKey = key.replace('primary_address_', '');
                addressObj[newKey] = ownerObj[key];
            }
        }
    }
    newOwnerObj.address = Address(addressObj);

    return {
        ...newOwnerObj,
        /**
         * Converts the data of a model to the format to display it in the custom table
         * mainly use in the confirmation pages
         */
        toCustomTable() {
            return [
                ['Owner first name', this.firstName],
                ['Owner last name', this.lastName],
                ['Phone number', this.getFullPhoneNumber().replace('+610', '+61')],
                ['Email address', this.email],
                ['Home address', typeof this.address === 'object' ? this.address.getSingleLineAddress() : ''],
            ];
        },
        /**
         * Validates the data to submit, the keys/values are the required fields
         * @returns {Array} an string array of the fields with errors or empty array if it's valid
         */
        validateRequiredData() {
            const emailRegEx = /\S+@\S+\.\S+/;
            const emailValidation = emailRegEx.test(this.email) ? this.email : '';
            let phoneNumberValidation = '';
            if ((this.phoneNumber.length === 10 && this.phoneNumber.startsWith('02'))
            || (this.phoneNumber.length === 10 && this.phoneNumber.startsWith('03'))
            || (this.phoneNumber.length === 10 && this.phoneNumber.startsWith('04'))
            || (this.phoneNumber.length === 10 && this.phoneNumber.startsWith('07'))
            || (this.phoneNumber.length === 10 && this.phoneNumber.startsWith('08'))
                || (this.phoneNumber.length === 9 && this.phoneNumber.charAt(0) !== '0')) {
                phoneNumberValidation = this.phoneNumber;
            }
            const addressValidation = this.address?.city ? this.address : '';
            let requiredValidation = validateForm({
                firstName: this.firstName,
                lastName: this.lastName,
                phoneNumber: phoneNumberValidation,
                address: addressValidation,
            });

            // Map the error array
            requiredValidation = requiredValidation.map(validation => {
                return {
                    field: validation,
                    message: '',
                };
            });

            // Validate the email field only if its has a value
            if (!isEmpty(this.email) && isEmpty(emailValidation)) {
                requiredValidation.push({
                    field: 'email',
                    message: 'Please enter valid email address',
                });
            }

            return requiredValidation;
        },
        getFullName() {
            let fullName = this.firstName ? this.firstName : '';
            fullName += this.lastName ? ` ${this.lastName}` : '';
            return fullName;
        },
        getFullPhoneNumber() {
            if (this.phoneNumber) {
                // if the number is 812312312 it returns +610812312312
                if (
                    !this.phoneNumber.startsWith('+610')
                    && !this.phoneNumber.startsWith('0')
                    && !this.phoneNumber.startsWith('+61')
                ) {
                    return `+610${this.phoneNumber}`;
                    // if the number is 0812312312 it returns +610812312312
                } else if (!this.phoneNumber.startsWith('+61') && this.phoneNumber.startsWith('0')) {
                    const phone = '+61' + this.phoneNumber.substring(1);
                    return phone;
                }
                return this.phoneNumber;
            }
            return '';
        },
        getShortPhoneNumber() {
            if (!this.phoneNumber) {
                return '';
            }
            if (this.phoneNumber.startsWith('+610')) {
                // if the number is +610812312312 it returns 812312312
                return this.phoneNumber.replace('+610', '');
            } else if (this.phoneNumber.startsWith('+61')) {
                // if the number is +61812312312 it returns 812312312
                return this.phoneNumber.replace('+61', '');
            } else if (this.phoneNumber.startsWith('0')) {
                // if the number is 0812312312 it returns 812312312
                return this.phoneNumber.substring(1);
            }
            return this.phoneNumber;
        },
        getPhoneType() {
            const shortPhoneNumber = this.getShortPhoneNumber();
            if (shortPhoneNumber.charAt(0) === '4') {
                return PHONE_TYPES.mobile
            } else if (shortPhoneNumber.charAt(0) === '2' || shortPhoneNumber.charAt(0) === '3' || shortPhoneNumber.charAt(0) === '7' || shortPhoneNumber.charAt(0) === '8') {
                return PHONE_TYPES.home
            } else {
                return PHONE_TYPES.work;
            }
            // return shortPhoneNumber.charAt(0) === '4' ? PHONE_TYPES.mobile : PHONE_TYPES.work;
        }
    };
};

export default Owner;
